const defaultOptions = {
  radius: 350,
  border: true,
  borderColor: '#3388ff',
  borderOpacity: 1,
  borderWidth: 2,
  fill: true,
  fillColor: '#3388ff',
  fillOpacity: 1,
  popup: undefined
};


class CircleModel {
  constructor(lat, lng, options = {}) {
    if (typeof lat !== 'number') { throw new Error('Invalid \'lat\' supplied to \'CircleModel.ctor\''); }
    if (typeof lng !== 'number') { throw new Error('Invalid \'lng\' supplied to \'CircleModel.ctor\''); }
    if (typeof options !== 'object') { throw new Error('Invalid \'options\' supplied to \'CircleModel.ctor\''); }

    this.lat = lat;
    this.lng = lng;
    this.options = { ...defaultOptions, ...options };

    this.compareShapes = CircleModel.compareShapes;
  }

  get latLng() { return [this.lat, this.lng]; }

  static compareShapes = (a, b) => {
    if (typeof a !== 'object' || typeof b !== 'object') {
      throw new Error('Invalid "CircleModel" param supplied to "CircleModel.compareShapes"');
    }

    if (a.lat !== b.lat) return false;
    if (a.lng !== b.lng) return false;

    return true;
  };

}

export { CircleModel };
